const { sanitiseBatchNo } = require('../../../batch/tools')
const { SHIPSY_SOURCE, STOCK_TRANSACTION_TYPES } = require('../../constants')

// Invoice payload (may arrive wrapped in a one-item array):
//   [{ request_id, invoiced_by, invoice_date, orders: [
//        { order_reference, items: [{ sku_code, batch_details: [
//            { batch_no, invoice_quantity,
//              location_details: [{ zone, location, quantity }] }
//          ] }] }
//      ] }]
// Invoice ships stock from warehouse to customer. origin/destination come
// from the referenced order shipment.
async function extract (rawPayload, { mainApi }) {
  const payload = Array.isArray(rawPayload) ? rawPayload[0] : rawPayload
  const orders = payload && payload.orders
  if (!Array.isArray(orders) || orders.length === 0) return []

  const orderReference = orders[0].order_reference
  if (!orderReference) return []

  let shipment
  try {
    shipment = await mainApi.shipment.getShipmentByNumber({ shipmentNumber: orderReference })
  } catch (err) {
    return []
  }
  if (!shipment) return []

  const requestId = String(payload.request_id)
  const createdAt = payload.invoice_date
  const createdBy = payload.invoiced_by
  const rows = []

  for (const order of orders) {
    if (!Array.isArray(order.items)) continue
    for (const item of order.items) {
      if (!Array.isArray(item.batch_details)) continue
      for (const batchDetail of item.batch_details) {
        const locationDetails = Array.isArray(batchDetail.location_details) && batchDetail.location_details.length
          ? batchDetail.location_details
          : [{ zone: null, quantity: batchDetail.invoice_quantity }]
        for (const loc of locationDetails) {
          const quantity = Number(loc.quantity)
          if (quantity <= 0) continue
          rows.push({
            source: SHIPSY_SOURCE,
            type: STOCK_TRANSACTION_TYPES.INVOICE,
            request_id: requestId,
            origin: shipment.origin.id,
            origin_zone: loc.zone || null,
            destination: shipment.destination.id,
            destination_zone: null,
            sku: String(item.sku_code),
            batch: sanitiseBatchNo(batchDetail.batch_no || 'UNKNOWN'),
            quantity,
            reason: null,
            payload: { item_sku: item.sku_code, batch: batchDetail, location: loc },
            created_at: createdAt,
            created_by: createdBy,
            updated_at: createdAt,
            updated_by: createdBy
          })
        }
      }
    }
  }

  return rows
}

module.exports = extract
